import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
	fabLabel: {
		display: 'block',
	},
	dangerIconWrapper: {
		background: '#fff',

		'&:hover': {
			background: '#fff',
		},
	},
	dangerIconPosition: {
		position: 'absolute',
		top: 0,
		left: 0,
	},
	tooltipLabel: {
		margin: '0 10px',
	},
});
